function getStyleValue(element, property) {
    return window.getComputedStyle(element, null).getPropertyValue(property);
}

function getLineHeight(element) {
    var lineHeight = getStyleValue(element, 'line-height');

    if (lineHeight === 'normal') {
        return parseInt(getStyleValue(element, 'font-size'), 10) * 1.25;
    }

    return parseFloat(lineHeight);
}

function setupLineHeight(element) {
    for (var index = 0; index < element.childNodes.length; index++) {
        var childNode = element.childNodes[index];

        if (childNode.nodeType === 1) {
            childNode.inlineCssText = childNode.style.cssText;
            childNode.style.lineHeight = '100%';
        }
    }
}

function removeLineHeight(element) {
    for (var index = 0; index < element.childNodes.length; index++) {
        var childNode = element.childNodes[index];

        if (childNode.nodeType === 1) {
            childNode.removeAttribute('style');

            if (childNode.inlineCssText) {
                childNode.style.cssText = childNode.inlineCssText;
            }
        }
    }
}

function truncateTextNode(textNode, rootElement, maxHeight) {
    var textContent = textNode.textContent;

    textNode.textContent = '';

    if (rootElement.clientHeight > maxHeight) return false;

    var chunks = textContent.split(' ');

    while (chunks.pop()) {
        textNode.textContent = chunks.join(' ');

        if (rootElement.clientHeight <= maxHeight) {
            textNode.textContent = textContent;
            break;
        }

        textContent = textNode.textContent;
    }

    var length = textContent.length;

    while (length > 2) {
        textContent = textContent.substring(0, --length);

        textNode.textContent = textContent + '…';

        if (rootElement.clientHeight <= maxHeight) return true;
    }

    return false;
}

function truncateElementNode(element, rootElement, maxHeight, lineHeight) {
    var childNodes = element.childNodes;
    var length = childNodes.length - 1;

    while (length > -1) {
        var childNode = childNodes[length--];
        var func = childNode.nodeType === 1 ? truncateElementNode : truncateTextNode;

        if (func(childNode, rootElement, maxHeight, lineHeight)) return true;

        element.removeChild(childNode);
    }

    return false;
}

function truncate(rootElement, lineCount) {
    var lineHeight = getLineHeight(rootElement);
    var maxHeight = Math.round(lineHeight * lineCount);

    if (rootElement.clientHeight <= maxHeight) return;

    setupLineHeight(rootElement);
    truncateElementNode(rootElement, rootElement, maxHeight, lineHeight);
    removeLineHeight(rootElement);
}

function native(rootElement, lineCount) {
    rootElement.style.overflow = 'hidden';
    rootElement.style.textOverflow = 'ellipsis';
    rootElement.style.webkitBoxOrient = 'vertical';
    rootElement.style.display = '-webkit-box';
    rootElement.style.webkitLineClamp = lineCount;
}

function webkitLineClamp(element, lineCount) {
    if (!lineCount) return;

    (typeof element.style.webkitLineClamp === 'undefined' ? truncate : native)(element, lineCount);
}

var blogPostsTextItems = document.querySelectorAll('.blog-list__item-text');
var blogPostsTitles = document.querySelectorAll('.blog-list__item-title');
var successPostsTitles = document.querySelectorAll('.success-stories-list__item-title');
var successPostsTextItems = document.querySelectorAll('.success-stories-list__item-text');

function addClampForTextItems(textItems, counter){
    for(var i=0; i<textItems.length; i++){
        webkitLineClamp(textItems[i] ,counter)
    }
}

function addClampForPostsTitle(titles, counter){
    for(var i=0; i<titles.length; i++){
        webkitLineClamp(titles[i] ,counter)
    }
}

function deleteCallContextMenu(){
    $('.tabs-list-link, .tags-list-link, .menu-btn').on('contextmenu', function(e){
        return false;
    })
}

addClampForPostsTitle(blogPostsTextItems, 3);
addClampForTextItems(blogPostsTitles,3);

addClampForPostsTitle(successPostsTitles, 5);
addClampForTextItems(successPostsTextItems,3 );

deleteCallContextMenu();